import { GenIcon } from 'react-icons';
export const MdPartners = GenIcon({
    tag: 'svg',
    attr: { fill: 'none', viewBox: '0 0 24 24' },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#a)', fill: 'currentColor' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M5.791 8.67c-.533.934-1.174 3.293.205 5.528 1.274 2.028 3.397 2.667 4.132 2.86l-.4 1.508C4.606 17.292 2.194 13.14 3.24 8.954c.933-3.298 4.605-6.482 9.573-5.88 4.36.621 5.817 4.325 2.05 7.228-1.924 1.56-4.349 2.353-7.522 2.53v-1.307c.995-.071 4.042-.4 6.249-2.707.653-.693.875-1.432.622-2.085-.313-.808-1.293-1.374-2.436-1.405C9.404 5.254 6.95 6.635 5.79 8.669Z',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M20.438 9.789c-.202-.418-.537-.68-.966-.753-.636-.082-1.105.344-1.555.753-.121.11-.241.22-.363.317-.65.608-2.571 2.303-5.405 2.896l.324 1.296.27-.05c1.24-.234 3.317-.625 5.488-2.05-.262 2.99-2.747 4.37-4.692 4.91l.389 1.463c2.544-.633 4.705-2.14 5.704-3.995.97-1.796 1.304-3.764.806-4.787ZM11.227 16.281 10.532 21h2.591l-.695-4.719h-1.201Z',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'a' },
                    child: [
                        {
                            tag: 'path',
                            attr: {
                                fill: 'currentColor',
                                d: 'M0 0h24v24H0z',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
